import DashboardView from '../views/dashboard/DashboardView'
import AdminDashboardView from '../views/dashboard/AdminDashboardView'
import IAdminDashboardView from '../views/dashboard/IAdminDashboardView'
import WorkspaceView from '../views/workspace/WorkspaceView'
import WorkspacePreview from '../views/workspace/WorkspacePreview'
import ReportsView from '../views/reporting/ReportsView'
import SummaryView from '../views/summary/SummaryView'

// Admin Views
import FormsView from '../views/administration/FormsView'
import AddFormView from '../views/administration/AddFormView'
import EditFormView from '../views/administration/EditFormView'
import CopyFormView from '../views/administration/CopyFormView'
import PreviewFormView from '../views/administration/PreviewForm'
import ReportingGroupsView from '../views/administration/ReportingGroupsView'
import UsersView from '../views/administration/UsersView'
import IssuesView from '../views/administration/IssuesView'
import CardAccessView from '../views/administration/CardAccessView'
import AnnouncementsView from '../views/administration/AnnouncementsView'

import FormGroupPresetsView from '../views/administration/FormGroupPresetsView'

const SubRoutes = [
    {
        path: "/admin-dashboard",
        name : "Admin Dashboard",
        meta : {
            isAdminView : false
        },
        components : {
            main : AdminDashboardView
        }
    },
    {
        path: "/ia-dashboard",
        name : "IA Dashboard",
        meta : {
            isAdminView : false
        },
        components : {
            main : IAdminDashboardView
        }
    },
    {
        path: "/dashboard",
        name : "Dashboard",
        meta : {
            isAdminView : false
        },
        components : {
            main : DashboardView
        }
    },
    {
        path: "/preview-workspace",
        name : "Workspace Preview",
        meta : {
            isAdminView : false
        },
        components : {
            main : WorkspacePreview
        }
    },
    {
        path: "/workspace",
        name : "Workspace",
        meta : {
            isAdminView : false
        },
        components : {
            main : WorkspaceView
        }
    },
    {
        path: "/summary",
        name : "Summary",
        meta : {
            isAdminView : false
        },
        components : {
            main : SummaryView
        }
    },
    {
        path: "/report",
        name : "Report",
        meta : {
            isAdminView : false
        },
        components : {
            main : ReportsView
        }
    },
    {
        path : "/admin/forms/:formId/preview",
        meta : {
            isAdminView : true
        },
        name : "Preview Form",
        components : {
            main : PreviewFormView
        }
    },
    {
        path : "/admin/forms/:formId/copy",
        meta : {
            isAdminView : true
        },
        name : "Copy Form",
        components : {
            main : CopyFormView
        }
    },
    {
        path : "/admin/forms/:formId/edit",
        meta : {
            isAdminView : true
        },
        name : "Edit Form",
        components : {
            main : EditFormView
        }
    },
    {
        path : "/admin/forms/group",
        meta : {
            isAdminView : true
        },
        name : "Group Form",
        components : {
            main : FormGroupPresetsView
        }
    },
    {
        path : "/admin/forms/add",
        meta : {
            isAdminView : true
        },
        name : "Add Form",
        components : {
            main : AddFormView
        }
    },
    {
        path : "/admin/forms",
        meta : {
            isAdminView : true
        },
        name : "Forms",
        components : {
            main : FormsView
        }
    },
    {
        path : "/admin/reporting-groups",
        meta : {
            isAdminView : true
        },
        name : "Reporting Groups",
        components : {
            main : ReportingGroupsView
        }
    },
    {
        path : "/admin/users",
        meta : {
            isAdminView : true
        },
        name : "Users",
        components : {
            main : UsersView
        }
    },
    {
        path : "/admin/issues",
        meta : {
            isAdminView : true
        },
        name : "Issues",
        components : {
            main : IssuesView
        }
    },
    {
        path : "/admin/announcements",
        meta : {
            isAdminView : true
        },
        name : "Announcements",
        components : {
            main : AnnouncementsView
        }
    },
    {
        path : "/admin/vcards",
        meta : {
            isAdminView : true
        },
        name : "Cards and Access",
        components : {
            main : CardAccessView
        }
    }
];

export default SubRoutes;


// WEBPACK FOOTER //
// ./src/router/SubRoutes.js